import { useState, useCallback } from 'react'

export function useRaioXState<T extends Record<string, unknown>>(initialValues: T) {
  const [values, setValues] = useState<T>(initialValues)

  const updateValue = useCallback(<K extends keyof T>(key: K, value: T[K]) => {
    setValues((prev) => ({ ...prev, [key]: value }))
  }, [])

  const updateValues = useCallback((next: Partial<T>) => {
    setValues((prev) => ({ ...prev, ...next }))
  }, [])

  const resetValues = useCallback(() => {
    setValues(initialValues)
  }, [initialValues])

  return { values, updateValue, updateValues, resetValues }
}
